import { useSetAtom } from "../editor-jotai";
import { t } from "../i18n";

import { activeConfirmDialogAtom } from "./ActiveConfirmDialog";
import { ToolButton } from "./ToolButton";
import { TrashIcon } from "./icons";

import "./ClearCanvasToolButton.scss";

/** Toolbar shortcut to the "clear canvas" confirm dialog. */
export const ClearCanvasToolButton = () => {
  const setActiveConfirmDialog = useSetAtom(activeConfirmDialogAtom);
  const label = t("buttons.clearReset");

  return (
    <ToolButton
      className="Shape ClearCanvasToolButton"
      type="button"
      icon={TrashIcon}
      title={label}
      aria-label={label}
      data-testid="toolbar-clear-canvas"
      onClick={() => setActiveConfirmDialog("clearCanvas")}
    />
  );
};
